import { type ReactElement } from 'react';

import { useI18n } from '@/i18n';

export function TelegramOnlyScreen(): ReactElement {
  const { t } = useI18n();

  return (
    <div className="flex min-h-screen items-center justify-center p-6 text-center">
      <div className="max-w-sm">
        <div className="mx-auto mb-4 flex size-14 items-center justify-center rounded-2xl bg-secondary text-2xl">
          ✈️
        </div>
        <h1 className="mb-2 text-lg font-semibold">{t('auth.telegramOnlyTitle')}</h1>
        <p className="text-sm leading-relaxed text-muted">{t('auth.telegramOnlyDescription')}</p>
      </div>
    </div>
  );
}
